<template>
  <div>
    <div v-if="!innerIsReview">
      <validation-provider
              v-slot="{ errors }"
              :name="label || 'This'"
              :rules="rules"
              v-bind="providerProps"
              v-show="innerShouldShow"
              :vid="'validate-' + fieldAssignmentId"
      >
        <span class="field-directions" v-if="directions" v-html="directions"></span>
        <v-text-field
                v-model="tag"
        ></v-text-field>
      </validation-provider>
    </div>
    <div v-else>
      <type-review
              v-if="extraProps"
              :label="label"
              :directions="directions"
              :should-show="innerShouldShow"
              :show-edit-button="extraProps.editButton"
              :page-number="extraProps.originalPageNumber"
              @goToPage="goToPage($event)"
      >
        <div v-if="innerValue && innerValue[type_attributes]">
          <span v-html="innerValue[type_attributes]"></span>
        </div>
        <div v-else>N/A</div>
      </type-review>
    </div>
  </div>
</template>

<script>
import formMixin from "../formMixin";
import TypeReview from "./TypeReview";

export default {
  name: 'TypeLanguageTag',
  mixins: [formMixin],
  inheritAttrs: false,
  components: {
    TypeReview
  },
  mounted() {
    this.fieldLoaded(); // signal to the form we are loaded
  },
  computed: {
    defaults() {
      return {
        label: this.innerLabel,
        directions: this.directions,
        persistentHint: true,
      }
    },
    rules() {
      return (this.enableValidation) ? {
        ...this.validation_settings,
        ...{required: !!this.validation_settings.required && !!this.innerShouldShow}
      } : {}
    },
    tag: {
      get() {
        return this.innerValue && this.innerValue[this.type_attributes] || '';
      },
      set(t) {
        if( !this.innerValue )
          this.innerValue = {};

        this.innerValue[this.type_attributes] = t;
        console.log('set', t, this.innerValue);
      }
    }
  },
}
</script>
